import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { StatusCodes } from 'http-status-codes';
import { useParams } from 'react-router-dom';
import { ReactComponent as DownloadPendingIcon } from 'icons/semi-ellipse.svg';
import { ReactComponent as DottedCircle } from 'icons/dotted-circle.svg';
import Button, { BUTTON_TYPES } from 'components/common/button-component';
import { importOmniaDetails } from 'api/statement-api';
import { omniaAutoTagAndMapElements } from 'store/actions/trial-balance/trial-balance-action';

const TRIAL_BALANCE_IMPORT_BLOCK = 'trial-balance-import';
const ICON_SIZE = 40;

const TrialBalanceImport = ({
  getOmniaSnapshotData,
  isDisabledImportButton,
}) => {
  const { projectId, statementId, revisionId } = useParams();
  const dispatch = useDispatch();
  const [isImporting, setIsImporting] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onImportDataFromOmnia = async () => {
    try {
      setIsImporting(true);
      const response = await importOmniaDetails({
        clientId: parseInt(projectId),
        statementId,
        revisionId,
      });
      if (response.status === StatusCodes.CREATED) {
        await dispatch(omniaAutoTagAndMapElements());
        await getOmniaSnapshotData();
      }
    } catch (error) {
      setHasError(true);
    } finally {
      setIsImporting(false);
    }
  };

  return (
    <div className={TRIAL_BALANCE_IMPORT_BLOCK}>
      <div className={`${TRIAL_BALANCE_IMPORT_BLOCK}__content`}>
        {isImporting && (
          <>
            <div className={`${TRIAL_BALANCE_IMPORT_BLOCK}__loader-icon`}>
              <DownloadPendingIcon
                width={ICON_SIZE}
                height={ICON_SIZE}
                className={`${TRIAL_BALANCE_IMPORT_BLOCK}__download-pending-icon`}
              />
            </div>
            <div className={`${TRIAL_BALANCE_IMPORT_BLOCK}__fetching-message`}>
              <FormattedMessage id="trial-balance-view.import.loading.message" />
            </div>
          </>
        )}

        {!isImporting && (
          <div
            className={classnames(
              `${TRIAL_BALANCE_IMPORT_BLOCK}__circle-icon`,
              {
                [`${TRIAL_BALANCE_IMPORT_BLOCK}__circle-icon--disabled`]:
                  hasError,
              },
            )}
          >
            <DottedCircle />
          </div>
        )}
        {!hasError && !isImporting && (
          <>
            <div className={`${TRIAL_BALANCE_IMPORT_BLOCK}__sync-message`}>
              <FormattedMessage id="trial-balance-view.sync.message" />
            </div>
            <div>
              <FormattedMessage id="trial-balance-view.project.link.to.omnia.message" />
            </div>
          </>
        )}

        {hasError && !isImporting && (
          <>
            <div className={`${TRIAL_BALANCE_IMPORT_BLOCK}__error-message`}>
              <FormattedMessage id="trial-balance-view.import.error.message" />
            </div>
          </>
        )}

        <div className={`${TRIAL_BALANCE_IMPORT_BLOCK}__btn`}>
          <Button
            id={`save`}
            className={`save`}
            onClick={onImportDataFromOmnia}
            type={BUTTON_TYPES.primary}
            disabled={isImporting || isDisabledImportButton}
          >
            <FormattedMessage id="trial-balance-view.import.button.text" />
          </Button>
        </div>
      </div>
    </div>
  );
};
export default TrialBalanceImport;
 